import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { CustomButton } from 'components'

export const FormDadosEndereco = (props) => {
  const {
    formPericiando,
    cidades,
    estados,
    handleSearchCep,
    cepMask,
    classes,
  } = props

  return (
    <Grid container spacing={2} className={classes.fieldGroup}>
      {/* CEP & Botão Pesquisar */}
      <Grid item container alignItems="center" spacing={2} xs={12}>
        <Grid item md={4} sm={6} xs={12}>
          <TextField
            error={formPericiando.hasError('cep')}
            fullWidth
            helperText={formPericiando.hasError('cep') ? formPericiando.formState.errors.cep[0] : null}
            label="CEP"
            name="cep"
            onChange={(e) => formPericiando.handleChangeWithModification(e, cepMask)}
            value={formPericiando.formState.values.cep || ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item md={2} sm={2} xs={12}>
          <CustomButton
            variant="contained"
            colorType="primary"
            onClick={handleSearchCep}
            style={{ height: '52px' }}
          >
            Pesquisar
          </CustomButton>
        </Grid>
      </Grid>

      {/* Endereço & Número */}
      <Grid item md={8} sm={8} xs={12}>
        <TextField
          error={formPericiando.hasError('endereco')}
          fullWidth
          helperText={formPericiando.hasError('endereco') ? formPericiando.formState.errors.endereco[0] : null}
          inputProps={{
            maxLength: 75,
          }}
          label="ENDEREÇO"
          name="endereco"
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.endereco || ''}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item md={4} sm={4} xs={12}>
        <TextField
          error={formPericiando.hasError('numeroResidencial')}
          fullWidth
          helperText={formPericiando.hasError('numeroResidencial') ? formPericiando.formState.errors.numeroResidencial[0] : null}
          label="NÚMERO"
          name="numeroResidencial"
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.numeroResidencial || ''}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>


      <Grid item md={4} sm={4} xs={12}>
        <AutocompleteNative
          value={formPericiando.formState.values.estadoEndereco || null}
          name="estadoEndereco"
          noOptionsText="Sem informações"
          options={estados}
          getOptionSelected={(option, value) => option.sigla === value.uf}
          onChange={(event, newValue) => {
            formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'estadoEndereco')
          }}
          getOptionLabel={(option) => `${option.sigla}`}
          renderOption={(option) => `${option.sigla}`}
          renderInput={(params) => (
            <TextField
              {...params}
              label="ESTADO"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>


      {/* Cidade */}
      <Grid item md={4} sm={4} xs={12}>
        <AutocompleteNative
          value={formPericiando.formState.values.municipio || null}
          name="municipio"
          noOptionsText="Sem informações"
          options={cidades}
          getOptionSelected={(option, value) => {
            const optionNome = option?.nome?.toUpperCase() || ''
            const valueNome = typeof value === 'string' ? value.toUpperCase() : (value?.nome?.toUpperCase() || '')
            return optionNome === valueNome
          }}
          onChange={(event, newValue) => {
            formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'municipio')
          }}
          getOptionLabel={(option) => {
            if (typeof option === 'string') return option
            return option?.nome || ''
          }}
          renderOption={(option) => {
            if (typeof option === 'string') return option
            return option?.nome || ''
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="CIDADE"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>



      {/* Bairro & Complemento */}
      <Grid item md={4} sm={4} xs={12}>
        <TextField
          id="bairro"
          error={formPericiando.hasError('bairro')}
          fullWidth
          helperText={formPericiando.hasError('bairro') ? formPericiando.formState.errors.bairro[0] : null}
          label="BAIRRO"
          name="bairro"
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.bairro || ''}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item md={8} sm={8} xs={12}>
        <TextField
          id="complemento"
          error={formPericiando.hasError('complemento')}
          fullWidth
          helperText={formPericiando.hasError('complemento') ? formPericiando.formState.errors.complemento[0] : null}
          inputProps={{
            maxLength: 100,
          }}
          label="COMPLEMENTO"
          name="complemento"
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.complemento || ''}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  )
}
